var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { components } from "react-select";
const { ValueContainer } = components;
export const CustomValueContainer = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const commonProps = {
        cx: props.cx,
        clearValue: props.clearValue,
        getStyles: props.getStyles,
        getValue: props.getValue,
        hasValue: props.hasValue,
        isMulti: props.isMulti,
        isRtl: props.isRtl,
        isDisabled: props.isDisabled,
        isFocused: props.isFocused,
        options: props.options,
        selectOption: props.selectOption,
        setValue: props.setValue,
        selectProps: props.selectProps,
        innerProps: props.innerProps,
        theme: props.theme,
    };
    return (React.createElement(ValueContainer, Object.assign({}, props), React.Children.map(children, (child) => {
        return child ? (child) : props.hasValue ? (React.createElement(components.SingleValue, Object.assign({}, commonProps, { data: props.getValue(), isDisabled: props.selectProps.isDisabled }), props.selectProps.getOptionLabel(props.getValue()[0]))) : (React.createElement(components.Placeholder, Object.assign({}, commonProps, { key: "placeholder" }), props.selectProps.placeholder));
    })));
};
//# sourceMappingURL=CustomValueContainer.js.map